import { useBreakpoint } from '@/hooks/useBreakpoint';
import styles from './styles.module.scss';
import { WithClassName } from '@/blocks/components/types';
import classNames from 'classnames';
import React, { forwardRef, useCallback, useRef } from 'react';

export const DataGridRowDecoration = forwardRef<HTMLSpanElement, WithClassName>(
  function DataGridRowDecoration({ className }, ref) {
    return <span className={classNames(styles.badge, className)} ref={ref}></span>;
  },
);

export function useDatagridRowDecorationsPosition() {
  const refDecorationLeft = useRef<HTMLSpanElement>(null);
  const refDecorationRight = useRef<HTMLSpanElement>(null);
  const bp = useBreakpoint();

  function showRowDecorations() {
    refDecorationLeft?.current?.classList.add(styles.visible);
    refDecorationRight?.current?.classList.add(styles.visible);
  }

  function hideRowDecorations() {
    refDecorationLeft?.current?.classList.remove(styles.visible);
    refDecorationRight?.current?.classList.remove(styles.visible);
  }

  const onMouseLeaveOrEnter = useCallback(
    (e: React.MouseEvent<HTMLTableRowElement>) => {
      if (bp !== 'desktop') {
        return;
      }

      const row = e.currentTarget;
      const dataGrid = row.closest('.MuiDataGrid-root');

      const decorationLeft = refDecorationLeft.current;
      const decorationRight = refDecorationRight.current;

      if (!row || !dataGrid || !decorationLeft || !decorationRight) {
        return;
      }

      const rowRect = e.currentTarget.getBoundingClientRect();
      const dataGridRect = dataGrid?.getBoundingClientRect();

      if (row.classList.contains('MuiDataGrid-row--lastVisible')) {
        dataGrid.classList[e.type === 'mouseleave' ? 'remove' : 'add'](styles.datagridNoBottomRadius);
      }

      if (e.type === 'mouseleave') {
        return hideRowDecorations();
      }

      showRowDecorations();

      const top = rowRect.top + window.scrollY;

      decorationLeft.style.top = top + 'px';
      decorationRight.style.top = top + 'px';

      decorationLeft.style.height = rowRect.height + 'px';
      decorationRight.style.height = rowRect.height + 'px';

      decorationLeft.style.left = dataGridRect.left - decorationLeft.getBoundingClientRect().width + 'px';
      decorationRight.style.left = dataGridRect.right + 'px';
    },
    [bp],
  );

  return {
    onMouseLeaveOrEnter,
    refDecorationLeft,
    refDecorationRight,
  };
}
